import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import PlanAdminInvoiceRow from '@app/components/Invoice/PlanAdminInvoiceRow'

export default function InvoicePaymentTable({ invoicesData, fetchEmrOrderById }) {
  // Calculate the number of columns to span (7 columns in this table)
  const columnCount = 7

  return (
    <TableContainer component={Paper}>
      <Table aria-label='collapsible table'>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell align='center'>Amount</TableCell>
            <TableCell align='center'>Invoice ID</TableCell>
            <TableCell align='center'>Status</TableCell>
            <TableCell align='center'>Paid Date</TableCell>
            <TableCell align='center'>Finalized Date</TableCell>
            <TableCell align='center'>Invoice </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoicesData && invoicesData.length > 0 ? (
            invoicesData.map((row) => (
              <PlanAdminInvoiceRow key={row.id} row={row} fetchEmrOrderById={fetchEmrOrderById} />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columnCount} align='center' sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                  <Typography variant='h6' color='text.secondary' gutterBottom>
                    No Invoices Found
                  </Typography>
                  <Typography variant='body2' color='text.secondary'>
                    There are no invoices in your check register at this time.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
